import { Button, Label } from '@repo/shadcn';
import { FaEraser, FaTrashRestore } from 'react-icons/fa';
import { IoReturnUpBack } from 'react-icons/io5';
import { RiDraftFill } from 'react-icons/ri';

import { CartListItem } from '@/features/slice/cart/cart.schema';

import { useAppDispatch } from '../../../../features';
import { openModal } from '../../../../features/slice/event/event-slice';

export const CartAction = ({
    cartData,
    clearCartApi,
    clearCartLoading,
}: {
    cartData: CartListItem[];
    clearCartLoading: boolean;
    clearCartApi: any;
}) => {
    const dispatch = useAppDispatch();

    const changer = async () => {
        if (!cartData.length) return;

        await clearCartApi();
    };
    return (
        <>
            <div className=" my-3 flex items-center  justify-between">
                <Label className="text-[20px] text-primary">
                    Total Items : <b>{cartData.length}</b>
                </Label>
                <div className=" flex gap-4">
                    <Button
                        type="button"
                        disabled={cartData.length > 0}
                        className=" flex select-none items-center bg-blue-100 text-blue-800"
                        variant="secondary"
                        onClick={() =>
                            dispatch(
                                openModal({
                                    content: 'Show Sales Return',
                                }),
                            )
                        }
                    >
                        <IoReturnUpBack className=" mr-1" /> Sales Return
                    </Button>
                    <Button
                        type="button"
                        disabled={cartData.length > 0}
                        className=" flex select-none items-center bg-green-100 text-green-800"
                        variant="secondary"
                        onClick={() =>
                            dispatch(
                                openModal({
                                    content: 'Show Draft',
                                }),
                            )
                        }
                    >
                        <FaTrashRestore className=" mr-1" /> Restore Cart
                    </Button>
                    <Button
                        disabled={!cartData.length}
                        onClick={() =>
                            dispatch(
                                openModal({
                                    content: 'Save Draft',
                                }),
                            )
                        }
                        type="button"
                        className=" flex select-none items-center bg-yellow-100 text-yellow-800"
                        variant="secondary"
                    >
                        <RiDraftFill className=" mr-1" /> Save as Draft
                    </Button>
                    <Button
                        disabled={!cartData.length}
                        type="button"
                        onClick={changer}
                        className=" flex w-[120px] select-none items-center bg-red-100 text-red-800"
                        variant="secondary"
                    >
                        {clearCartLoading ? (
                            'Clearing...'
                        ) : (
                            <>
                                <FaEraser className=" mr-1" /> Clear Cart
                            </>
                        )}
                    </Button>
                </div>
            </div>
        </>
    );
};
